<template>
  <base-modal
    :isOpen="isOpen"
    persistent
    width="500"
    title="Add Call Reason"
    @close="onClose"
    :icon="{
      name: 'solar:call-chat-outline',
      color: 'info',
      bgColor: 'info1',
    }"
  >
    <div class="d-flex justify-space-between align-center">
      <contact-details-element-avatar
        :title="callerInfo.name"
        :subtitle1="callerInfo.role"
        :subtitle2="callerInfo.company_name"
        :avatar="callerInfo.avatar"
      />
      <div>
        <span class="text-grey200"> {{ callerInfo.number }} </span>
        <base-icon
          icon="codicon:call-outgoing"
          color="success5"
          bgColor="success1"
        />
      </div>
    </div>

    <div class="grey-section rounded-lg pa-2">
      <div class="text-grey5 text-subtitle-1">{{ $t("Call Id") }}:</div>
      <base-chip-material
        :text="callerInfo.callid"
        color="info"
        variant="flat"
        append-icon="solar:hashtag-circle-bold"
      />
    </div>

    <v-form ref="reasonCallForm" @submit.prevent="submitForm" class="my-6">
      <contact-call-reason-form />
      <button type="submit" class="hidden" />
    </v-form>

    <template #footer>
      <base-button
        name="Submit"
        variant="flat"
        :disabled="!validForm"
        :loading="loading"
        @click="submitForm"
        type="submit"
        class="w-80"
      />
    </template>
  </base-modal>
</template>

<script setup>
import { useContactCallStore } from "~/stores/contact/call";

const contactCallStore = useContactCallStore();

const props = defineProps({
  isOpen: Boolean,
});
const emit = defineEmits(["close"]);

const callerInfo = computed(() => contactCallStore.callerInfo);

const loading = ref(false);
const reasonCallForm = ref(null);

const validForm = computed(() => {
  if (!reasonCallForm.value) return false;
  return reasonCallForm.value.isValid;
});

const submitForm = async () => {
  const { valid } = await reasonCallForm.value.validate();
  if (!valid) return;

  loading.value = true;
  await contactCallStore.submitCallReason();
  await contactCallStore.submitReminder(callerInfo.value);
  onClose();
};

const onClose = () => {
  loading.value = false;
  reasonCallForm.value.reset();
  contactCallStore.resetReasonInfo()
  emit("close");
};
</script>

<style scoped>
.grey-section {
  display: flex;
  justify-content: space-between;
  background-color: rgb(var(--v-theme-greyLightest));
  border: 1px solid rgb(var(--v-theme-grey3));
}
</style>
